module.exports = __webpack_public_path__ + "static/policyicon-92d66eb07f38e9f6aba2a9027dc641f7.jpg";